import React, {Component} from 'react';

import axios from 'axios';

import CodeReviewModal from './CodeReviewModalComponent';
import YesNoModal from '../../YesNoModalComponent';


import {serverPath} from "../../common";

class SubmissionOptionsModals extends Component
{
	constructor(props)
	{

		super(props);

		this.state=
			{
				/*Info about modals*/
				testCaseListModalShow:false	,
				codeReviewModalShow:false,
				showCodeModalShow:false,
				submissionSelected:null,
				codeReviewModalDirty:false,
				yesNoModalShow:false
			};

		this.toggleTestCaseListModal= this.toggleTestCaseListModal.bind(this);
		this.toggleCodeReviewModal = this.toggleCodeReviewModal.bind(this);
		this.toggleShowCodeModal = this.toggleShowCodeModal.bind(this);
		this.onSetCodeReview = this.onSetCodeReview.bind(this);	
		this.onSetCodeReviewModalDirty = this.onSetCodeReviewModalDirty.bind(this);
		this.onYes = this.onYes.bind(this);
		this.toggleYesNoModal = this.toggleYesNoModal.bind(this);

		this._toggleTestCaseListModal= ()=>
			this.toggleTestCaseListModal(this.state.submissionSelected);
		this._toggleShowCodeModal = ()=>this.toggleShowCodeModal(this.state.submissionSelected);
		this._toggleCodeReviewModal = ()=>
		this.toggleCodeReviewModal(this.state.submissionSelected);
	}


	toggleTestCaseListModal(submission)
	{
		this.setState((prevState) => (
			{
				testCaseListModalShow:!prevState.testCaseListModalShow,
				submissionSelected:submission
			}));
	}

	toggleCodeReviewModal(submission)
	{
		if(this.state.codeReviewModalShow && this.state.codeReviewModalDirty)
		{
			this.setState({yesNoModalShow:true});
			return ;
		}

		this.setState((prevState) => (
			{
				codeReviewModalShow:!prevState.codeReviewModalShow,
				submissionSelected:submission
			}));
	}

	toggleShowCodeModal(submission)
	{
		this.setState((prevState) => (
			{
				showCodeModalShow:!prevState.showCodeModalShow,
				submissionSelected:submission

			}));
	}

	onSetCodeReview(submissionId, codeReview)
	{
		axios.post(serverPath + 'professorService.php', 
		{
			submissionId:submissionId,
			codeReview:codeReview,
			professorId:this.props.userId,
		},
		{
			params:
			{
				action:'setCodeReview'
			}
		});
		//pedja sorry
		var params = new FormData();
		params.append("action", "addReviewNotification");
		params.append("submissionId", submissionId);
		params.append("professorId", this.props.userId);
		axios.post(serverPath + "notificationService.php", params);

		this.props.onSubmissionListChanged(submissionId, codeReview);
	}

	onSetCodeReviewModalDirty(value, then)
	{
		var tmp = {codeReviewModalDirty:value};
		if(then !== undefined)
		{
			this.setState(tmp, then);
		}
		else
		{
			this.setState(tmp);
		}
	}

	onYes()
	{
		this.setState({codeReviewModalShow:false, codeReviewModalDirty:false});
	}

	toggleYesNoModal()
	{
		this.setState((prevState)=>({yesNoModalShow:!prevState.yesNoModalShow}));
	}


	render()
	{
		return (
			<React.Fragment>

				{this.props.render(
					{
						toggleTestCaseListModal:this.toggleTestCaseListModal,
						toggleShowCodeModal:this.toggleShowCodeModal,
						toggleCodeReviewModal:this.toggleCodeReviewModal

					}
				)}
					


				<CodeReviewModal toggle={this._toggleCodeReviewModal}
					isOpen={this.state.codeReviewModalShow}
					submission={this.state.submissionSelected}
					onSetCodeReview={this.onSetCodeReview}
					onSetCodeReviewModalDirty={this.onSetCodeReviewModalDirty}
					/>

				<YesNoModal toggle={this.toggleYesNoModal}
					isOpen = {this.state.yesNoModalShow}
					title='Nesacuvane promene'
					body = 'Niste sacuvali promene da li ste sigurni da zelite da izadjete'
					onYes = {this.onYes}
					yesText = 'Da'
					noText = 'Ne'
				/>
			</React.Fragment>
		);
	}
}

export default SubmissionOptionsModals;
